import React from 'react';
import Routes from '../Routes';
import './App.less';

function App() {
  return <Routes />;
}

export default App;
